import api from "./api";
import { login, logout } from "../auth";
import { handleReportsByUserWithCard } from 'services/api/reports'
import { setErrors } from "utils";

export const handleUsers = async () =>
  (await api.post(`/users/list-by-firm/users`)).data;

export const handleGeneratePassword = async (id) =>
  (await api.post(`/users/generate-password/${id}`)).data;

export const handleUsersByRoles = async (roles) =>
  (await api.post(`/users/list-by-firm-and-roles`, { roles })).data;

export const handleUserLogin = async (history, data, setMessages) => {
  const { email, password, aadToken, appName, appUrl, company } = data

  const uniqueId = crypto.randomUUID()

  try {
    const { token, user } = !aadToken ? 
      (await api.post(`/users/login`, { email, password, uniqueId, company })).data :
      (await api.post(`/users/login/microsoft`, { aadToken, appName, appUrl })).data

    localStorage.setItem('company', JSON.stringify(user.company))
    login(token, uniqueId);

    if (user.roles === "admin") {
      return history.push(`/grupos`);
    }

    const reports = await handleReportsByUserWithCard()
    const { data: carousels } = await api.get(`/users-carousels`)

    if (reports.length === 1 && carousels.length === 0) {
      const report = reports[0]

      return history.push(`/grupos/${report.group_id}/relatorios/${report.report_id}/datasets/${report.dataset_id}`)
    }

    return history.push(`/relatorios`);
  } catch (error) {
    if (error.response) {
      setMessages({ messages: setErrors(error) || 'KKk', alert: "alert-orange" });
      return
    }

    setMessages({ messages: 'Sistema inativo no momento!', alert: "alert-orange" });
  }
};

export const handleUserForgotPassword = async (data, setMessages) => {
  const values = {
    emailTo: data.email,
    forgotPasswordPageUrl: data.data ? `${process.env.REACT_APP_URL_APP}/${data.data.slug}/recuperar-senha` : `${process.env.REACT_APP_URL_APP}/recuperar-senha`
  };
  try {
    const response = await api.post(`/users/forgot-password`, values);
    setMessages({ messages: response.data.data.message, alert: "alert-green" });
  } catch (error) {
    setMessages({ messages: setErrors(error), alert: "alert-orange" });
  }
};

export const handleUserRecoverPassword = async (
  history,
  token,
  data,
  setMessages,
  company
) => {
  try {
    await api.put(`/users/recover-password/${token}`, data);
    return history.push(company ? `/${company.slug}` : "/login");
  } catch (error) {
    setMessages({ messages: setErrors(error), alert: "alert-orange" });
  }
};

export const handleStoreUser = async (history, data, setMessages) => {
  const values = {
    name: data.name,
    email: data.email,
    roles: data.roles,
    appName: "exph",
    appUrl: process.env.REACT_APP_URL_APP,
    company_id: data.company_id === "" ? null : data.company_id,
  };
  try {
    await api.post(`/users/store-auth-user`, values);
    return history.push(`/usuarios`);
  } catch (error) {
    setMessages({ messages: setErrors(error), alert: "alert-orange" });
  }
};

export const handleUpdateUser = async (history, data, userId, setMessages) => {
  if (data.company_id === "") delete data.company_id 
  
  try {
    await api.put(`/users/${userId}/update-auth-user`, data);
    return history.push(`/usuarios`);
  } catch (error) {
    setMessages({ messages: setErrors(error), alert: "alert-orange" });
  }
};

export const handleUpdateViewReportOptions = async (data, userId) => {
  await api.put(`/users/${userId}/view-report-options`, data)
}


export const handleUserUpdateFile = async (data, id) => {
  const values = new FormData();
  values.append("file", data);
  try {
    await api.put(`/users/${id}/upload`, values);
    return;
  } catch (error) {
    return error;
  }
};

export const handleUserUpdatePassword = async (history, data, setMessages, slug) => {
  try {
    await api.put(`/users/update-password`, data);
    logout(history, slug);
    return;
  } catch (error) {
    setMessages({ messages: setErrors(error), alert: "alert-orange" });
  }
};

export const handleUpdateProfile = async (
  history,
  profileId,
  data,
  setMessages,
  slug
) => {
  const values = {
    name: data.name,
    email: data.email,
  };

  try {
    await api.put(`/users`, values);
    logout(history, slug);
    return;
  } catch (error) {
    setMessages({ messages: setErrors(error), alert: "alert-orange" });
  }
};

export const handleUserShow = async (id) =>
  (await api.get(`/users/${id}`)).data;

export const handleUserDelete = async (id, history) => {
  await api.delete(`/users/${id}`);
  return history.push("/usuarios");
};
